<template>
  <div class="input-group" :class="{'input-group-invalid': isInvalid, 'input-group-disabled': isDisabled}">
    <label>
      <FieldLabel :is-required="isRequired" :wo-label="woLabel" :label-link-text="labelLinkText" :label-link-url="labelLinkUrl"><slot>{{ label }}</slot></FieldLabel>
      <input
          v-mask="masks"
          type="tel"
          :disabled="isDisabled"
          :placeholder="placeholder || 'CPF ou CNPJ'"
          v-model="inputValue"
          @blur="() => validate()"
          @input="() => inputHandle()"
      >
      <span v-if="isInvalid && hasTouched" class="error-message">{{ errorMsg }}</span>
    </label>
  </div>
</template>

<script>
import { VueMaskDirective } from 'maska'
import { defaultProps } from './defaultProps'
import { validCPF } from '../../services/validation/validCPF'
import { validCNPJ } from '../../services/validation/validCNPJ'

export default {
  name: 'i-cpf-cnpj',
  props: { ...defaultProps },
  directives: {
    mask: VueMaskDirective
  },
  data: () => ({
    masks: ['###.###.###-##', '##.###.###/####-##'],
    inputValue: null,
    isInvalid: false,
    hasTouched: false,
    woLabel: Boolean,
    errorMsg: '',
  }),
  computed: {
    cleanValue() {
      return (this.inputValue || '').replace(/[^\d]/g, '')
    },
    isCnpj() {
      return this.cleanValue.length > 11
    },
  },
  methods: {
    inputHandle() {
      this.hasTouched = true
      this.$emit('input', this.inputValue)
      if (this.isInvalid) this.validate()
    },
    validate() {
      if (!this.inputValue && this.isRequired) {
        this.isInvalid = true
        this.errorMsg = 'Campo obrigatório'
        return
      }
      if (!this.inputValue || !this.hasTouched) {
        this.isInvalid = false
        this.errorMsg = ''
        return
      }
      if (this.isCnpj) {
        const valid = validCNPJ(this.inputValue)
        this.isInvalid = !valid
        this.errorMsg = valid ? '' : 'CNPJ inválido'
      } else {
        const valid = validCPF(this.inputValue)
        this.isInvalid = !valid
        this.errorMsg = valid ? '' : 'CPF inválido'
      }
    },
    clean() {
      this.inputValue = null
      this.isInvalid = false
      this.hasTouched = false
      this.errorMsg = ''
    },
    isValid() {
      this.validate()
      return !this.isInvalid
    },
  },
  watch: {
    value: {
      handler(v) {
        this.inputValue = v
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
.error-message {
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 2px;
  display: block;
}
</style>
